"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.helpCenterURL = exports.getHelpCenterLink = exports.VISUALIZER_UI = exports.TUTORIALS = exports.TRAINING = exports.SECURITY_UI = exports.SECRETS_MANAGER_UI = exports.RUNTIME_MANAGER_UI = exports.RPA = exports.PARTNER_MANAGER_UI = exports.MQ_UI = exports.MONITORING_UI = exports.LEGACY_PARTNER_MANAGER_UI = exports.IDP = exports.HELP_CENTER = exports.FORUMS = exports.DOCUMENTATION = exports.COMPOSER = exports.API_GOVERNANCE_UI = exports.AEH_UI = void 0;
// Reusable config objects for products

var RPA = exports.RPA = {
  name: 'RPA Manager',
  description: 'Eliminate manual tasks and processes at scale using simple and advanced robotic process automations.',
  cta: 'Go to RPA Manager',
  icon: 'rpa-manager',
  childProducts: []
};
var COMPOSER = exports.COMPOSER = {
  name: 'Composer',
  description: 'Empower lines of business with a no-code solution to connecting apps and creating automations.',
  cta: 'Go to Composer',
  icon: 'composer',
  newWindow: true,
  childProducts: []
};
var IDP = exports.IDP = {
  name: 'Intelligent Document Processing',
  description: 'Use AI-based intelligent document processing to read and analyze documents for your automation.',
  icon: 'idp',
  cta: 'Get Started',
  href: '/idp/'
};
var LEGACY_PARTNER_MANAGER_UI = exports.LEGACY_PARTNER_MANAGER_UI = {
  name: 'Partner Manager',
  description: 'Manage trading partners & view transactions.',
  icon: 'partner-manager',
  href: '/b2b/portal/'
};
var PARTNER_MANAGER_UI = exports.PARTNER_MANAGER_UI = {
  name: 'Partner Manager',
  description: 'Manage trading partners & view transactions.',
  icon: 'partner-manager',
  href: '/partnermanager/'
};
var RUNTIME_MANAGER_UI = exports.RUNTIME_MANAGER_UI = {
  name: 'Runtime Manager',
  description: 'Deploy, manage, and monitor deployed applications.',
  icon: 'runtime-manager',
  href: '/cloudhub/#/console/home/applications'
};
var API_GOVERNANCE_UI = exports.API_GOVERNANCE_UI = {
  name: 'API Governance',
  description: 'Govern and monitor API conformance.',
  icon: 'governance',
  href: '/governance/'
};
var MQ_UI = exports.MQ_UI = {
  name: 'MQ',
  description: 'Send messages using queues & pub-sub services.',
  icon: 'message-queue',
  href: '/mq/'
};
var VISUALIZER_UI = exports.VISUALIZER_UI = {
  name: 'Visualizer',
  description: 'Visualize your Application Network.',
  icon: 'visualizer',
  href: '/visualizer/'
};
var MONITORING_UI = exports.MONITORING_UI = {
  name: 'Monitoring',
  description: 'Create alerts for and troubleshoot applications.',
  icon: 'monitoring',
  href: '/monitoring/'
};
var AEH_UI = exports.AEH_UI = {
  name: 'API Experience Hub',
  description: 'Create and manage your API Portal.',
  icon: 'api-experience-hub',
  href: '/api-experience-hub/'
};
var SECRETS_MANAGER_UI = exports.SECRETS_MANAGER_UI = {
  name: 'Secrets Manager',
  description: 'Manage public keys for SSL communication.',
  icon: 'secrets-manager',
  href: '/secrets-manager/'
};
var SECURITY_UI = exports.SECURITY_UI = {
  name: 'Security',
  description: 'Protect network access with policies and proxying',
  icon: 'edge-security',
  href: '/securityfabric/'
};

// ********************* //
// SUPPORT URLS
// ********************* //

var DOCUMENTATION = exports.DOCUMENTATION = {
  name: 'Documentation',
  description: '',
  icon: 'documentation',
  // gray
  href: 'https://docs.mulesoft.com/',
  newWindow: true,
  hiddenFromSidebar: true
};
var FORUMS = exports.FORUMS = {
  name: 'Forums',
  description: '',
  icon: 'forum-small',
  // gray
  href: 'https://forums.mulesoft.com/',
  newWindow: true,
  hiddenFromSidebar: true
};
var helpCenterURL = exports.helpCenterURL = {
  qax: 'https://mulee2e-mulesoftprm.cs37.force.com/s/',
  stgx: 'https://muleuat1-mulesoftprm.cs196.force.com/s/',
  prod: 'https://help.mulesoft.com/'
};
var getHelpCenterLink = exports.getHelpCenterLink = function getHelpCenterLink() {
  if (typeof window !== 'undefined') {
    var env = window.location.hostname.split('.')[0];
    if (env === 'qax') {
      return helpCenterURL.qax;
    } else if (env === 'stgx') {
      return helpCenterURL.stgx;
    }
  }
  return helpCenterURL.prod;
};
var HELP_CENTER = exports.HELP_CENTER = {
  name: 'Help Center',
  description: '',
  icon: 'support-portal-small',
  // gray
  href: getHelpCenterLink(),
  newWindow: true,
  hiddenFromSidebar: true
};
var TRAINING = exports.TRAINING = {
  name: 'Training',
  description: '',
  icon: 'training-small',
  // gray
  href: 'https://help.mulesoft.com/s/training',
  newWindow: true,
  hiddenFromSidebar: true
};
var TUTORIALS = exports.TUTORIALS = {
  name: 'Tutorials',
  description: '',
  icon: 'compass',
  // gray
  href: 'https://developer.mulesoft.com/tutorials',
  newWindow: true,
  hiddenFromSidebar: true
};
//# sourceMappingURL=productConfigurations.js.map